<template>
  <div>
    <div class="container-fluid">
      <div class="page-title" style="margin-top: -20px;">
        <div class="row mt-4">
          <div class="col-6 d-flex">
            <h3>{{ title }}</h3>
          </div>
          <div class="col-6">
            <ol class="breadcrumb custom-breadcrumb">
              <!-- Home link -->
              <li class="breadcrumb-item">
                <router-link :to="{ path: '/' }">
                  <svg class="stroke-icon">
                    <use href="@/assets/svg/icon-sprite.svg#stroke-home"></use>
                  </svg>
                </router-link>
              </li>

              <!-- Loop through breadcrumb paths -->
              <li
                  v-for="(crumb, index) in breadcrumbs"
                  :key="index"
                  class="breadcrumb-item"
                  :class="{ active: index === breadcrumbs.length - 1 }"
              >
                <router-link
                    v-if="crumb.path && index !== breadcrumbs.length - 1"
                    :to="crumb.path"
                >
                  {{ crumb.label }}
                </router-link>
                <span v-else>{{ crumb.label }}</span>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Home",
    },
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
  },
};
</script>



<style scoped>
/* Override default breadcrumb styles while keeping the existing layout */
.page-wrapper .page-body-wrapper .page-title .breadcrumb {
  background-color: transparent !important;
  padding: 0 !important;
  margin-bottom: 0 !important;
  align-items: center !important;
  justify-content: flex-end !important;
}

/* Styling for breadcrumb items */
.page-wrapper .page-body-wrapper .page-title .breadcrumb .breadcrumb-item {
  font-size: 13px;
  letter-spacing: 1px;
  font-family: Roboto, sans-serif;
  color: #000 !important; /* Black color */
  font-weight: 500;
}

.page-wrapper .page-body-wrapper .page-title .breadcrumb .breadcrumb-item a {
  color: #000 !important; /* Ensuring links are also black */
  text-decoration: none;
}

.page-wrapper .page-body-wrapper .page-title .breadcrumb .breadcrumb-item a:hover {
  text-decoration: underline;
}

/* Separator between breadcrumb items */
.page-wrapper .page-body-wrapper .page-title .breadcrumb .breadcrumb-item + .breadcrumb-item:before {
  content: "/";
  color: #000 !important; /* Separator color */
}

/* SVG icons inside breadcrumb links */
.page-wrapper .page-body-wrapper .page-title .breadcrumb .breadcrumb-item a svg {
  width: 16px;
  height: 16px;
  stroke: #2c323f;
  vertical-align: text-top;
}

/* Active breadcrumb item */
.page-wrapper .page-body-wrapper .page-title .breadcrumb .breadcrumb-item.active {
  color: #143D60 !important; /* Red color */
  font-weight: bold !important;
}

.page-wrapper .page-body-wrapper .page-title .breadcrumb .breadcrumb-item.active a {
  color: #143D60 !important;
}
</style>
